require('./main.css');

